import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  admin,
  useGetBannerListDataQuery,
  useUpdateBannerHeadDataMutation,
  useUpdateBannerStatusMutation,
} from "../../../store/queries/Admin";
import {
  getBannerEditData,
  updateConfig,
} from "../../../store/slices/Admin/Banner/bannerSlice";
import { IconText } from "@wac-ui-dashboard/wac_component_library";
import { deleteBanner } from "./api";
import { toast } from "react-toastify";
import { current } from "@reduxjs/toolkit";
const useBanner = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageData, setImageData] = useState("");
  const dispatch = useDispatch();
  const bannerState = useSelector((state) => state.banner);
  const { selectedId } = useSelector((state) => state.banner);
  const { showEditModal } = useSelector((state) => state.global);
  const {
    data: bannerList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetBannerListDataQuery({
    page_size: bannerState?.currentPageSize,
    page: bannerState?.currentPage,
    sort: bannerState?.sortBy,
    sort_order: bannerState?.sortOrder,
    search: bannerState?.search,
  });
  const [updateBannerFields] = useUpdateBannerHeadDataMutation();
  const [updateBannerStatus] = useUpdateBannerStatusMutation();
  const handleCreateClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.imagePreview = "";
        state.imageName = "";
        state.arabicImagePreview = "";
        state.arabicImageName = "";
        state.isEdit = false;
        state.editBannerData = {};
      })
    );
  };
  useEffect(() => {
    if (bannerState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [bannerState.clearSelection]);

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleViewImage = (data) => {
    setShowImageModal(() => true);
    setImageData(data);
  };

  const handleToggle = (e, data) => {
    const newStatus = data.status === "Active" ? false : true;
    let body = {
      banner_id: data?.id,
      status: newStatus ? 1 : 2,
    };
    updateBannerStatus(body);
    dispatch(
      admin.util.updateQueryData(
        "getBannerListData",
        {
          page_size: bannerState?.currentPageSize,
          page: bannerState?.currentPage,
          sort: bannerState?.sortBy,
          sort_order: bannerState?.sortOrder,
          search: bannerState?.search,
        },
        (cacheEntry) => {
          let currentCache = { ...current(cacheEntry) };
          const newResult = currentCache.data.data?.map((res) =>
            res.id === data?.id
              ? {
                  ...res,
                  status: data.status === "Active" ? "Deactivated" : "Active",
                }
              : res
          );
          currentCache = {
            ...currentCache,
            data: {
              ...currentCache.data,
              data: newResult,
            },
          };
          return currentCache;
        }
      )
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.image_url)}
            />
          </div>
        );
      },
      alias_image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.alias_image_url)}
            />
          </div>
        );
      },
      status: (field, data) => {
        const isChecked = data?.status === "Active";
        return (
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={isChecked}
              onChange={(e) => handleToggle(e, data)}
            />
          </div>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleSort = (label) => {
    if (bannerState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = bannerState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedId = e?.[0];
      })
    );
  };

  const handleDelete = async () => {
    const response = await deleteBanner(selectedId);
    if (response && response.status === 200) {
      toast.success(`Banner deleted successfully.`);
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.search="";
          })
        );
    setTimeout(() => {
      refetch();
      }, 0);
    } else {
      toast.error(`Something went wrong !`);
    }
    handleDeleteModal();
    dispatch(
      updateConfig((state) => {
        state.clearSelection = true;
      })
    );
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const closeImageModal = () => {
    setShowImageModal(() => false);
    setImageData("");
  };

  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = true;
        state.selectedId = e?.[0];
        state.isEdit = true;
      })
    );
    dispatch(getBannerEditData(e?.[0]));
  };

  return {
    isLoading,
    imageData,
    isFetching,
    bannerList,
    showEditModal,
    bannerState,
    showImageModal,
    paginationOptions,
    handleEditColumnsClick,
    updateBannerFields,
    handleDeleteModal,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleSort,
    handleDelete,
    refetch,
    getRow,
  };
};

export default useBanner;
